// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import { useApolloFragment } from 'apollo-fragment-react';


export type OrganizationBaseDetailsFragment = (
  { __typename?: 'Organization' }
  & Pick<Types.Organization, 'id' | 'name' | 'status' | 'enforceCap' | 'blocked' | 'blockAt' | 'canUnblock'>
  & { rteSummary?: Types.Maybe<(
    { __typename?: 'RealTimeEditSummary' }
    & Pick<Types.RealTimeEditSummary, 'id' | 'RTEsInCurrentDay' | 'RTEsInCurrentPeriod' | 'limit'>
  )>, billing?: Types.Maybe<(
    { __typename?: 'BillingInformation' }
    & { creditCard?: Types.Maybe<(
      { __typename?: 'CreditCard' }
      & CreditCardFieldsFragment
    )>, plan?: Types.Maybe<(
      { __typename?: 'SubscriptionPlan' }
      & BillingPlanFieldsFragment
    )> }
    & BillingFieldsFragment
  )>, permissions?: Types.Maybe<(
    { __typename?: 'PermissionsDigest' }
    & PermissionsForOrganizationFragment
  )> }
);

export type OrganizationRepositoriesFragment = (
  { __typename?: 'Organization' }
  & Pick<Types.Organization, 'id' | 'siteCount'>
  & { repositoriesPaged?: Types.Maybe<(
    { __typename?: 'OrgRepositoryResult' }
    & { repos?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'SourceControlRepository' }
      & Pick<Types.SourceControlRepository, 'id' | 'name' | 'nameWithOwner' | 'url' | 'provider'>
      & { sites?: Types.Maybe<Array<Types.Maybe<(
        { __typename?: 'Site' }
        & Pick<Types.Site, 'id' | 'name' | 'publicName' | 'branch' | 'updatedAt' | 'previewUrl' | 'previewStatus' | 'previewProtection' | 'repositoryId' | 'buildsEnabled' | 'dataBuildsEnabled' | 'incrementalPreviewsEnabled' | 'previewBuildsEnabled' | 'parentOrganizationId' | 'merlinProductionSourcingEnabled'>
      )>>> }
    )>>>, pageInfo?: Types.Maybe<(
      { __typename?: 'CursorPageInfo' }
      & Pick<Types.CursorPageInfo, 'endCursor' | 'hasNextPage'>
    )> }
  )> }
);

export type OrganizationSiteNamesFragment = (
  { __typename?: 'Organization' }
  & Pick<Types.Organization, 'id' | 'siteCount'>
  & { repositoriesPaged?: Types.Maybe<(
    { __typename?: 'OrgRepositoryResult' }
    & { repos?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'SourceControlRepository' }
      & Pick<Types.SourceControlRepository, 'id'>
      & { sites?: Types.Maybe<Array<Types.Maybe<(
        { __typename?: 'Site' }
        & Pick<Types.Site, 'id' | 'name' | 'publicName'>
      )>>> }
    )>>>, pageInfo?: Types.Maybe<(
      { __typename?: 'CursorPageInfo' }
      & Pick<Types.CursorPageInfo, 'endCursor' | 'hasNextPage'>
    )> }
  )> }
);

export type BillingFieldsFragment = (
  { __typename?: 'BillingInformation' }
  & Pick<Types.BillingInformation, 'id' | 'status' | 'trialDaysRemaining' | 'trialStart' | 'trialEnd' | 'nextBillingDate' | 'canceledAt' | 'stripeCustomerId' | 'cancelAtPeriodEnd' | 'periodEnd'>
);

export type CreditCardFieldsFragment = (
  { __typename?: 'CreditCard' }
  & Pick<Types.CreditCard, 'name' | 'lastFour' | 'brand' | 'expMonth' | 'expYear'>
);

export type BillingPlanFieldsFragment = (
  { __typename?: 'SubscriptionPlan' }
  & Pick<Types.SubscriptionPlan, 'id' | 'planId' | 'name' | 'interval' | 'intervalCount' | 'amount' | 'formattedAmount' | 'features' | 'nextBillingDate' | 'buildsTier' | 'hostingTier'>
  & { baseFeatures?: Types.Maybe<(
    { __typename?: 'BaseFeatures' }
    & Pick<Types.BaseFeatures, 'tier' | 'cloudBuilds' | 'repositoryAccess' | 'domains' | 'functionTimeout' | 'thirdPartyHostingIntegrations' | 'customSSL' | 'sites'>
    & { requests?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'max' | 'quantity' | 'formattedQuantity' | 'amount' | 'formattedAmount'>
    )>, users?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'max' | 'quantity' | 'amount' | 'formattedAmount'>
    )>, bandwidth?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'max' | 'quantity' | 'formattedQuantity' | 'amount' | 'formattedAmount'>
    )>, invocations?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'max' | 'quantity' | 'formattedQuantity' | 'amount' | 'formattedAmount'>
    )>, concurrency?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'max' | 'quantity' | 'amount' | 'formattedAmount'>
    )>, monthlyBuildMinutes?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'max' | 'quantity' | 'formattedQuantity' | 'amount' | 'formattedAmount'>
    )>, totalSiteRoutes?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'max' | 'quantity' | 'formattedQuantity' | 'amount' | 'formattedAmount'>
    )>, imageCdnRequests?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'max' | 'quantity' | 'formattedQuantity' | 'amount' | 'formattedAmount'>
    )> }
  )>, additionalFeatures?: Types.Maybe<(
    { __typename?: 'FeaturesSummary' }
    & { requests?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'quantity' | 'formattedQuantity' | 'amount' | 'formattedAmount'>
    )>, users?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'quantity' | 'formattedQuantity' | 'amount' | 'formattedAmount'>
    )>, bandwidth?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'quantity' | 'formattedQuantity' | 'amount' | 'formattedAmount'>
    )>, invocations?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'quantity' | 'formattedQuantity' | 'amount' | 'formattedAmount'>
    )>, concurrency?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'max' | 'quantity' | 'amount' | 'formattedAmount'>
    )> }
  )>, totalFeatures?: Types.Maybe<(
    { __typename?: 'FeaturesSummary' }
    & { requests?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'quantity' | 'formattedQuantity'>
    )>, users?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'quantity' | 'formattedQuantity'>
    )>, bandwidth?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'quantity' | 'formattedQuantity'>
    )>, invocations?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'quantity' | 'formattedQuantity'>
    )>, concurrency?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'quantity' | 'formattedQuantity'>
    )>, monthlyBuildMinutes?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'quantity' | 'formattedQuantity'>
    )>, totalSiteRoutes?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'quantity' | 'formattedQuantity'>
    )>, imageCdnRequests?: Types.Maybe<(
      { __typename?: 'SubscriptionFeature' }
      & Pick<Types.SubscriptionFeature, 'quantity' | 'formattedQuantity'>
    )> }
  )> }
);

export type PermissionsForOrganizationFragment = (
  { __typename?: 'PermissionsDigest' }
  & Pick<Types.PermissionsDigest, 'id' | 'role'>
  & { billing?: Types.Maybe<(
    { __typename?: 'ResourcePermissionMap' }
    & Pick<Types.ResourcePermissionMap, 'read' | 'create' | 'edit'>
  )>, organization?: Types.Maybe<(
    { __typename?: 'ResourcePermissionMap' }
    & Pick<Types.ResourcePermissionMap, 'create' | 'read' | 'delete' | 'edit'>
  )>, sites?: Types.Maybe<(
    { __typename?: 'ResourcePermissionMap' }
    & Pick<Types.ResourcePermissionMap, 'edit' | 'read' | 'delete' | 'create'>
  )>, contributor?: Types.Maybe<(
    { __typename?: 'ContributorPermissionMap' }
    & Pick<Types.ContributorPermissionMap, 'read' | 'invite' | 'delete' | 'deleteSelf'>
  )> }
);

export type OrganizationPermissionsFieldsFragment = (
  { __typename?: 'Organization' }
  & Pick<Types.Organization, 'id'>
  & { permissions?: Types.Maybe<(
    { __typename?: 'PermissionsDigest' }
    & PermissionsForOrganizationFragment
  )> }
);

export type OrganizationSitesNameFieldsFragment = (
  { __typename?: 'Organization' }
  & Pick<Types.Organization, 'id'>
  & { repositories?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'SourceControlRepository' }
    & Pick<Types.SourceControlRepository, 'id'>
    & { sites?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'Site' }
      & Pick<Types.Site, 'id' | 'name' | 'publicName'>
    )>>> }
  )>>> }
);

export type OrganizationPlanFeaturesFragment = (
  { __typename?: 'Organization' }
  & Pick<Types.Organization, 'id'>
  & { billing?: Types.Maybe<(
    { __typename?: 'BillingInformation' }
    & Pick<Types.BillingInformation, 'id'>
    & { plan?: Types.Maybe<(
      { __typename?: 'SubscriptionPlan' }
      & Pick<Types.SubscriptionPlan, 'id'>
      & { baseFeatures?: Types.Maybe<(
        { __typename?: 'BaseFeatures' }
        & Pick<Types.BaseFeatures, 'sites' | 'domains' | 'thirdPartyHostingIntegrations'>
        & { users?: Types.Maybe<(
          { __typename?: 'SubscriptionFeature' }
          & Pick<Types.SubscriptionFeature, 'max' | 'quantity'>
        )> }
      )>, additionalFeatures?: Types.Maybe<(
        { __typename?: 'FeaturesSummary' }
        & { users?: Types.Maybe<(
          { __typename?: 'SubscriptionFeature' }
          & Pick<Types.SubscriptionFeature, 'quantity'>
        )> }
      )>, totalFeatures?: Types.Maybe<(
        { __typename?: 'FeaturesSummary' }
        & { users?: Types.Maybe<(
          { __typename?: 'SubscriptionFeature' }
          & Pick<Types.SubscriptionFeature, 'quantity'>
        )> }
      )> }
    )> }
  )> }
);

export const BillingFieldsFragmentDoc = gql`
    fragment billingFields on BillingInformation {
  id
  status
  trialDaysRemaining
  trialStart
  trialEnd
  nextBillingDate
  canceledAt
  stripeCustomerId
  cancelAtPeriodEnd
  periodEnd
}
    `;
export const CreditCardFieldsFragmentDoc = gql`
    fragment creditCardFields on CreditCard {
  name
  lastFour
  brand
  expMonth
  expYear
}
    `;
export const BillingPlanFieldsFragmentDoc = gql`
    fragment billingPlanFields on SubscriptionPlan {
  id
  planId
  name
  interval
  intervalCount
  amount
  formattedAmount
  features
  nextBillingDate
  buildsTier
  hostingTier
  baseFeatures {
    tier
    cloudBuilds
    repositoryAccess
    domains
    functionTimeout
    thirdPartyHostingIntegrations
    customSSL
    sites
    requests {
      max
      quantity
      formattedQuantity
      amount
      formattedAmount
    }
    users {
      max
      quantity
      amount
      formattedAmount
    }
    bandwidth {
      max
      quantity
      formattedQuantity
      amount
      formattedAmount
    }
    invocations {
      max
      quantity
      formattedQuantity
      amount
      formattedAmount
    }
    concurrency {
      max
      quantity
      amount
      formattedAmount
    }
    monthlyBuildMinutes {
      max
      quantity
      formattedQuantity
      amount
      formattedAmount
    }
    totalSiteRoutes {
      max
      quantity
      formattedQuantity
      amount
      formattedAmount
    }
    imageCdnRequests {
      max
      quantity
      formattedQuantity
      amount
      formattedAmount
    }
  }
  additionalFeatures {
    requests {
      quantity
      formattedQuantity
      amount
      formattedAmount
    }
    users {
      quantity
      formattedQuantity
      amount
      formattedAmount
    }
    bandwidth {
      quantity
      formattedQuantity
      amount
      formattedAmount
    }
    invocations {
      quantity
      formattedQuantity
      amount
      formattedAmount
    }
    concurrency {
      max
      quantity
      amount
      formattedAmount
    }
  }
  totalFeatures {
    requests {
      quantity
      formattedQuantity
    }
    users {
      quantity
      formattedQuantity
    }
    bandwidth {
      quantity
      formattedQuantity
    }
    invocations {
      quantity
      formattedQuantity
    }
    concurrency {
      quantity
      formattedQuantity
    }
    monthlyBuildMinutes {
      quantity
      formattedQuantity
    }
    totalSiteRoutes {
      quantity
      formattedQuantity
    }
    imageCdnRequests {
      quantity
      formattedQuantity
    }
  }
}
    `;
export const PermissionsForOrganizationFragmentDoc = gql`
    fragment permissionsForOrganization on PermissionsDigest {
  id
  role
  billing {
    read
    create
    edit
  }
  organization {
    create
    read
    delete
    edit
  }
  sites {
    edit
    read
    delete
    create
  }
  contributor {
    read
    invite
    delete
    deleteSelf
  }
}
    `;
export const OrganizationBaseDetailsFragmentDoc = gql`
    fragment organizationBaseDetails on Organization {
  id
  name
  status
  enforceCap
  rteSummary {
    id
    RTEsInCurrentDay
    RTEsInCurrentPeriod
    limit
  }
  billing {
    ...billingFields
    creditCard {
      ...creditCardFields
    }
    plan {
      ...billingPlanFields
    }
  }
  permissions {
    ...permissionsForOrganization
  }
  blocked
  blockAt
  canUnblock
}
    ${BillingFieldsFragmentDoc}
${CreditCardFieldsFragmentDoc}
${BillingPlanFieldsFragmentDoc}
${PermissionsForOrganizationFragmentDoc}`;
export const OrganizationRepositoriesFragmentDoc = gql`
    fragment organizationRepositories on Organization {
  id
  siteCount
  repositoriesPaged(
    searchText: $searchText
    limit: $limit
    nextCursor: $nextCursor
  ) {
    repos {
      id
      name
      nameWithOwner
      url
      provider
      sites {
        id
        name
        publicName
        branch
        updatedAt
        previewUrl
        previewStatus
        previewProtection
        repositoryId
        buildsEnabled
        dataBuildsEnabled
        incrementalPreviewsEnabled
        previewBuildsEnabled
        parentOrganizationId
        merlinProductionSourcingEnabled
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;
export const OrganizationSiteNamesFragmentDoc = gql`
    fragment organizationSiteNames on Organization {
  id
  siteCount
  repositoriesPaged(
    searchText: $searchText
    limit: $limit
    nextCursor: $nextCursor
  ) {
    repos {
      id
      sites {
        id
        name
        publicName
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;
export const OrganizationPermissionsFieldsFragmentDoc = gql`
    fragment OrganizationPermissionsFields on Organization {
  id
  permissions {
    ...permissionsForOrganization
  }
}
    ${PermissionsForOrganizationFragmentDoc}`;
export const OrganizationSitesNameFieldsFragmentDoc = gql`
    fragment OrganizationSitesNameFields on Organization {
  id
  repositories {
    id
    sites {
      id
      name
      publicName
    }
  }
}
    `;
export const OrganizationPlanFeaturesFragmentDoc = gql`
    fragment organizationPlanFeatures on Organization {
  id
  billing {
    id
    plan {
      id
      baseFeatures {
        sites
        users {
          max
          quantity
        }
        domains
        thirdPartyHostingIntegrations
      }
      additionalFeatures {
        users {
          quantity
        }
      }
      totalFeatures {
        users {
          quantity
        }
      }
    }
  }
}
    `;

  /**
   * __useBillingFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useBillingFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useBillingFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useBillingFieldsFragment('fragment-id');
   */
export function useBillingFieldsFragment(id: string) {
          return useApolloFragment<BillingFieldsFragment>(BillingFieldsFragmentDoc, id);
        }
export type BillingFieldsFragmentHookResult = ReturnType<typeof useBillingFieldsFragment>;

  /**
   * __useCreditCardFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useCreditCardFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useCreditCardFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useCreditCardFieldsFragment('fragment-id');
   */
export function useCreditCardFieldsFragment(id: string) {
          return useApolloFragment<CreditCardFieldsFragment>(CreditCardFieldsFragmentDoc, id);
        }
export type CreditCardFieldsFragmentHookResult = ReturnType<typeof useCreditCardFieldsFragment>;

  /**
   * __useBillingPlanFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useBillingPlanFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useBillingPlanFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useBillingPlanFieldsFragment('fragment-id');
   */
export function useBillingPlanFieldsFragment(id: string) {
          return useApolloFragment<BillingPlanFieldsFragment>(BillingPlanFieldsFragmentDoc, id);
        }
export type BillingPlanFieldsFragmentHookResult = ReturnType<typeof useBillingPlanFieldsFragment>;

  /**
   * __usePermissionsForOrganizationFragment__
   * To read a fragment data from Apollo Cache, call `usePermissionsForOrganizationFragment` and pass it the ID of the cached object.
   * When your component renders, `usePermissionsForOrganizationFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = usePermissionsForOrganizationFragment('fragment-id');
   */
export function usePermissionsForOrganizationFragment(id: string) {
          return useApolloFragment<PermissionsForOrganizationFragment>(PermissionsForOrganizationFragmentDoc, id);
        }
export type PermissionsForOrganizationFragmentHookResult = ReturnType<typeof usePermissionsForOrganizationFragment>;

  /**
   * __useOrganizationBaseDetailsFragment__
   * To read a fragment data from Apollo Cache, call `useOrganizationBaseDetailsFragment` and pass it the ID of the cached object.
   * When your component renders, `useOrganizationBaseDetailsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useOrganizationBaseDetailsFragment('fragment-id');
   */
export function useOrganizationBaseDetailsFragment(id: string) {
          return useApolloFragment<OrganizationBaseDetailsFragment>(OrganizationBaseDetailsFragmentDoc, id);
        }
export type OrganizationBaseDetailsFragmentHookResult = ReturnType<typeof useOrganizationBaseDetailsFragment>;

  /**
   * __useOrganizationRepositoriesFragment__
   * To read a fragment data from Apollo Cache, call `useOrganizationRepositoriesFragment` and pass it the ID of the cached object.
   * When your component renders, `useOrganizationRepositoriesFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useOrganizationRepositoriesFragment('fragment-id');
   */
export function useOrganizationRepositoriesFragment(id: string) {
          return useApolloFragment<OrganizationRepositoriesFragment>(OrganizationRepositoriesFragmentDoc, id);
        }
export type OrganizationRepositoriesFragmentHookResult = ReturnType<typeof useOrganizationRepositoriesFragment>;

  /**
   * __useOrganizationSiteNamesFragment__
   * To read a fragment data from Apollo Cache, call `useOrganizationSiteNamesFragment` and pass it the ID of the cached object.
   * When your component renders, `useOrganizationSiteNamesFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useOrganizationSiteNamesFragment('fragment-id');
   */
export function useOrganizationSiteNamesFragment(id: string) {
          return useApolloFragment<OrganizationSiteNamesFragment>(OrganizationSiteNamesFragmentDoc, id);
        }
export type OrganizationSiteNamesFragmentHookResult = ReturnType<typeof useOrganizationSiteNamesFragment>;

  /**
   * __useOrganizationPermissionsFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useOrganizationPermissionsFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useOrganizationPermissionsFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useOrganizationPermissionsFieldsFragment('fragment-id');
   */
export function useOrganizationPermissionsFieldsFragment(id: string) {
          return useApolloFragment<OrganizationPermissionsFieldsFragment>(OrganizationPermissionsFieldsFragmentDoc, id);
        }
export type OrganizationPermissionsFieldsFragmentHookResult = ReturnType<typeof useOrganizationPermissionsFieldsFragment>;

  /**
   * __useOrganizationSitesNameFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useOrganizationSitesNameFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useOrganizationSitesNameFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useOrganizationSitesNameFieldsFragment('fragment-id');
   */
export function useOrganizationSitesNameFieldsFragment(id: string) {
          return useApolloFragment<OrganizationSitesNameFieldsFragment>(OrganizationSitesNameFieldsFragmentDoc, id);
        }
export type OrganizationSitesNameFieldsFragmentHookResult = ReturnType<typeof useOrganizationSitesNameFieldsFragment>;

  /**
   * __useOrganizationPlanFeaturesFragment__
   * To read a fragment data from Apollo Cache, call `useOrganizationPlanFeaturesFragment` and pass it the ID of the cached object.
   * When your component renders, `useOrganizationPlanFeaturesFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useOrganizationPlanFeaturesFragment('fragment-id');
   */
export function useOrganizationPlanFeaturesFragment(id: string) {
          return useApolloFragment<OrganizationPlanFeaturesFragment>(OrganizationPlanFeaturesFragmentDoc, id);
        }
export type OrganizationPlanFeaturesFragmentHookResult = ReturnType<typeof useOrganizationPlanFeaturesFragment>;